import React, { useEffect, useState } from 'react'
import { COLORS } from '../../colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Message = (props) => {
    const [visible, setVisible] = useState(false)
    const [isFadeOut, setIsFadeOut] = useState(false)
    const [isError, setIsError] = useState(false)

    useEffect(() => {

        if (!props.message.trim().length) {
            setVisible(false)
            setIsFadeOut(false)
            setIsError(props.messageIsError);
            return
        }
        setIsError(props.messageIsError);
        setVisible(true)

        setIsFadeOut(false);

        if (!props.keepShown) {
            const timer = setTimeout(() => {
                setIsFadeOut(true);
                setVisible(false);
                setIsError(props.messageIsError);
            }, props.messageDelay);
            return () => clearTimeout(timer);
        }

    }, [props.message]);


    //const getStyle = (isError) => {
    //    if (isError) {
    //        return { backgroundColor: COLORS.secondary, color: COLORS.white, fontSize: "18px" }
    //    } else {
    //        return { backgroundColor: COLORS.primary, color: COLORS.white, fontSize: "18px" }
    //    }
    //}

    //const getIconClass = (isError) => {
    //    if (isError) {
    //        return 'fa-solid fa-triangle-exclamation'
    //    } else {
    //        return 'fas fa-info-circle'
    //    }
    //}

    const getClass = () => {
        return visible ? 'message' : !visible && isFadeOut ? 'message fade-out' : 'message hide';
    }
    const closeMessage = () => {
        setIsFadeOut(false)
        setVisible(false)
    }



    return (
        <>
            {

                isError ? (
                    <div className="message-container">
                        <div className={getClass()} style={{ backgroundColor: COLORS.secondary }} >
                            <span className="message__icon">
                                <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" className="icon-margin mx-2" />
                            </span>
                            <span className="message__text">{props.message}</span>
                            <button className="message__close" aria-label="close" onClick={closeMessage}>&times;</button>
                        </div>
                    </div>

                ) : (
                    <div className="message-container">
                        <div className={getClass()} style={{ backgroundColor: COLORS.primary }} >
                            <span className="message__icon">
                                <FontAwesomeIcon icon="fas fa-info-circle" className="icon-margin mx-2" />

                            </span>
                            <span className="message__text">{props.message}</span>
                            <button className="message__close" aria-label="close" onClick={closeMessage}>&times;</button>
                        </div>
                    </div>

                )


            }
        </>

    )

}

